<template>
  <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>{{ teacher.name }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-col lg12>
        <v-form ref="teacherForm" name="teacherForm">
          <v-col column wrap>
            <FileInput
              @file-selected="imageSelected"
              :field-name="'image'"
              :url="teacher.image.url"
            ></FileInput>
            <v-col lg12>
              <v-text-field
                v-model="teacher.name"
                label="Имя"
                name="name"
                :rules="[(v) => !!v || 'Это поле обязательно']"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-row row>
                <v-col lg6>
                  <v-text-field
                    v-model="teacher.contact"
                    label="Телефон"
                    name="contact"
                    :rules="[(v) => !!v || 'Это поле обязательно']"
                  ></v-text-field>
                </v-col>
                <v-col lg6>
                  <v-text-field v-model="teacher.email" label="Email" name="email"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col lg12>
              <ckeditor
                :editor="ckeditor"
                v-model="teacher.description"
                :config="ckConfig"
                type="classic"
                required
                :upload-adapter="UploadAdapter"
              >
              </ckeditor>
              <v-text-field
                style="display: none"
                name="description"
                v-model="teacher.description"
                :rules="[(v) => !!v || 'Это поле обязательно']"
              ></v-text-field>
            </v-col>
            <v-col lg3>
              <v-switch
                v-model="teacher.published"
                color="green"
                name="published"
                :label="teacher.published ? 'опубликован' : 'не опубликован'"
              ></v-switch>
            </v-col>
          </v-col>
          <v-row>
            <v-col lg6>
              <v-btn color="green" dark @click="save">Сохранить</v-btn>
            </v-col>
            <v-col lg6 align="right">
              <v-btn right color="warning" outlined @click="$emit('cancel')">Закрыть</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import FileInput from '@/components/FileInput'
import ckeditorMixin from '@/mixins/ckeditor'

export default {
  name: 'Teacher',
  components: { FileInput },
  mixins: [ckeditorMixin],
  props: {
    isEdit: { type: Boolean, default: false },
    site: { type: String, default: '' },
    onSaveRedirect: { type: Boolean, default: true },
  },
  data() {
    return {
      teacher: {
        name: '',
        image: { url: '' },
        description: '',
        contact: '',
        email: '',
      },
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getTeacherData()
    }
  },
  methods: {
    imageSelected(e) {
      this.teacher.image = e
    },
    getTeacherData() {
      if (!this.isEdit) {
        return
      }
      this.axios({
        url: `/v1/hps/teachers/${this.$route.params.id}`,
        method: 'get',
      })
        .then((resp) => {
          this.teacher = resp.data
        })
        .catch((err) => {
          this.$log.error('get teacher', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updateTeacher() {
      const d = new FormData(this.$refs.teacherForm.$el)
      d.set('published', this.teacher.published ? 1 : 0)
      this.axios({
        url: `/v1/hps/teachers/${this.teacher.id}`,
        method: 'post',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.teacher = resp.data
          this.$emit('teacher-update', this.teacher)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    save() {
      if (this.isEdit) {
        this.updateTeacher()
        return
      }
      const d = new FormData(this.$refs.teacherForm.$el)
      d.set('published', this.teacher.published ? 1 : 0)
      this.axios({
        url: '/v1/hps/teachers',
        method: 'post',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.teacher = resp.data
          this.$emit('teacher-create', this.teacher)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>
